import { Loader } from "components/Loader/Loader";
import "./transition.scss";
import { useEffect, useState } from "react";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCreateNeedsMutation } from "pages/dashboard/home/dashboardService";
import { useSelector } from "react-redux";
import { getDealApplicationId, getIsInterimDashboard, getCurrentUserId } from "features/authSlice";
import {
  Transition_StepOne_TimeOut,
  Transition_Steps,
  Transition_StepThree_TimeOut,
  Transition_StepTwo_TimeOut,
  Transition_Total_Steps,
} from "utilities/Constant";

interface TransitionProps {
  readonly onComplete: () => void;
}

export default function Transition({ onComplete }: TransitionProps) {
  const [completedSteps, setCompletedSteps] = useState<number[]>([]);
  const dealApplicationId = useSelector(getDealApplicationId);
  const [createNeeds] = useCreateNeedsMutation();
  const isInterimDashboard = useSelector(getIsInterimDashboard);
  const userId = useSelector(getCurrentUserId);
  useEffect(() => {
    const timeouts = [
      setTimeout(() => setCompletedSteps((prev) => [...prev, 0]), Transition_StepOne_TimeOut),
      setTimeout(() => setCompletedSteps((prev) => [...prev, 1]), Transition_StepTwo_TimeOut),
      setTimeout(() => setCompletedSteps((prev) => [...prev, 2]), Transition_StepThree_TimeOut),
    ];

    return () => timeouts.forEach(clearTimeout);
  }, []);

  useEffect(() => {
    const triggerCreateNeeds = async () => {
      await createNeeds({dealApplicationId,userId, isInterimDashboard}); // wait until createNeeds completes
      onComplete();
    };

    if (completedSteps.length === Transition_Total_Steps) {
      void triggerCreateNeeds();
    }
  }, [completedSteps]);

  return (
    <div className="transition-loader">
      <Loader />
      <div className="step-wrapper">
        {Transition_Steps.map((step, index) => (
          <div key={index} className="step-container">
            <FontAwesomeIcon icon={solid("circle-check")} className={`checkmark ${completedSteps.includes(index) ? "completed" : ""}`} />
            <div className="step">{step}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
